import {Component, OnInit} from '@angular/core';
import {formatDate} from '@angular/common';
import {InternetConnectionService} from '../services/internet-connection.service';
import {DialogHelperComponent} from '../helpers/dialog-helper';
import {DeviceHelperComponent} from '../helpers/device-helper';
import {ApplicationSettingsHelper} from '../helpers/application-settings-helper';
import {ConfigurationService} from '../../core/common/services/configuration.service';
import {environment} from '~/environments/environment';
import {KeycloakHelper} from '~/app/shared/helpers/keycloak-helper';
import {Router} from '@angular/router';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

    public appVersion: any;
    public isTablet: boolean;
    env = environment;

    constructor(public internetConnectionService: InternetConnectionService,
                public dialogHelper: DialogHelperComponent,
                public deviceHelper: DeviceHelperComponent,
                public applicationSettingsHelper: ApplicationSettingsHelper,
                private _configurationService: ConfigurationService,
                private _keycloakHelper: KeycloakHelper,
                private _router: Router,
                private _loadingIndicatorHelper: LoadingIndicatorHelper,
    ) {

    }

    ngOnInit(): void {
        this.isTablet = this.deviceHelper.isTablet();
        this.appVersion = this.deviceHelper.getApplicationVersion();
        console.log('Password:' + this.confirmPassword());
    }

    goBack() {
        this.deviceHelper.backToPreviousPage();
    }

    onEnvironmentModeChangedMobile() {
        this.dialogHelper.showEnvironmentChangeMobileDialog('Application Mode Change', 'Enter Password').then(async results => {
            // @ts-ignore
            if (results.text === this.confirmPassword()) {
                console.log('Current Mode: ' + this.applicationSettingsHelper.getApplicationMode());
                if (this.applicationSettingsHelper.getApplicationMode() === 'true') {
                    this.applicationSettingsHelper.setApplicationMode('false');
                } else if (this.applicationSettingsHelper.getApplicationMode() === 'false') {
                    this.applicationSettingsHelper.setApplicationMode('true');
                }
                console.log('Changed Mode: ' + this.applicationSettingsHelper.getApplicationMode());
                console.log('Password Confirmed!');
                // this._keycloakHelper.keycloakLoggingIn();
                const options = {
                    message: 'Logging Out...',
                };
                this._loadingIndicatorHelper.show(options);
                await this.dialogHelper.showConfirmDialogOkOnly('Success!', 'Logging out session to apply changes.').then(async () => {
                    await this._keycloakHelper.keycloakLogout('');
                    await this._router.navigate(['/login']);
                    this._loadingIndicatorHelper.hide();
                });
            } else {
                console.log('User canceled or invalid password');
            }
        });
    }

    confirmPassword() {
        // Password Algorithm - 987 + two digit month + add up all date digits. EX. 04/02/2020  0 + 4 + 0 + 2 + 2 + 0 + 2 + 0 = 10
        // Password: 987 + (Month) 04 + (Total Date Digits' Value) 10 = 9870410
        const date = formatDate(new Date().toString(), 'MMddyyyy', 'en');
        const buildPassword = Number(date.slice(0, 1)) + Number(date.slice(1, 2)) + Number(date.slice(2, 3)) + Number(date.slice(3, 4)) + Number(date.slice(4, 5)) + Number(date.slice(5, 6)) + Number(date.slice(6, 7)) + Number(date.slice(7, 8));
        return '987' + date.slice(0, 2) + buildPassword;
    }
}
